/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const runtimeEnvironments = {
  LOCAL: {
    releaseTogglesEndpoint: "/tdm-release-toggling/public/toggles",
    releaseToggleUpdateEndpoint: "/tdm-release-toggling/toggles",
    userInfoUrl: "/tdm-users/public/current-user",
    feedbackEndpoint: "/tdm-users/feedback",
    alerts: "/tdm-alerts/public/alerts",
    notificationsCount: "/tdm-notifications/notifications/unread-count",
    assetsLibraryVersion: "",
    glassboxScriptUrl: "",
    pendoApiKey: "",
    graphUrl: "/graphql",
    chatBotResourceRoute: "tdp-chat-widget-mfe/main.js",
    companyAttestationEnabled: true,
    sctHost: "techdirect-uat2.servicecentral.com",
  },
  STAGING: {
    releaseTogglesEndpoint: "/tdm-release-toggling/public/toggles",
    releaseToggleUpdateEndpoint: "/tdm-release-toggling/toggles",
    userInfoUrl: "/tdm-users/public/current-user",
    feedbackEndpoint: "/tdm-users/feedback",
    alerts: "/tdm-alerts/public/alerts",
    notificationsCount: "/tdm-notifications/notifications/unread-count",
    assetsLibraryVersion: "/latest",
    glassboxScriptUrl:
      "https://nexus.ensighten.com/dell/externalDev/Bootstrap.js",
    pendoApiKey: "6b05824a-5874-43f9-4aa4-58432d1f2d2a",
    graphUrl: "/graphql",
    chatBotResourceRoute: "tdp-chat-widget-mfe/latest/main.js",
    companyAttestationEnabled: true,
    sctHost: "techdirect-uat.dell.com",
  },
  INT: {
    releaseTogglesEndpoint: "/tdm-release-toggling/public/toggles",
    releaseToggleUpdateEndpoint: "/tdm-release-toggling/toggles",
    userInfoUrl: "/tdm-users/public/current-user",
    feedbackEndpoint: "/tdm-users/feedback",
    alerts: "/tdm-alerts/public/alerts",
    notificationsCount: "/tdm-notifications/notifications/unread-count",
    assetsLibraryVersion: "/latest",
    glassboxScriptUrl:
      "https://nexus.ensighten.com/dell/externalDev/Bootstrap.js",
    pendoApiKey: "6b05824a-5874-43f9-4aa4-58432d1f2d2a",
    graphUrl: "/graphql",
    chatBotResourceRoute: "tdp-chat-widget-mfe/latest/main.js",
    companyAttestationEnabled: true,
    sctHost: "techdirect-uat2.dell.com",
  },
  PROD: {
    production: true,
    releaseTogglesEndpoint: "/tdm-release-toggling/public/toggles",
    releaseToggleUpdateEndpoint: "/tdm-release-toggling/toggles",
    userInfoUrl: "/tdm-users/public/current-user",
    feedbackEndpoint: "/tdm-users/feedback",
    alerts: "/tdm-alerts/public/alerts",
    notificationsCount: "/tdm-notifications/notifications/unread-count",
    assetsLibraryVersion: "/latest",
    glassboxScriptUrl: "https://nexus.ensighten.com/dell/external/Bootstrap.js",
    pendoApiKey: "6b05824a-5874-43f9-4aa4-58432d1f2d2a",
    graphUrl: "/graphql",
    chatBotResourceRoute: "tdp-chat-widget-mfe/latest/main.js",
    companyAttestationEnabled: true,
    sctHost: "techdirect.dell.com",
  },
};
